<template>
  <div class="side">
    <ul class="nav-list">
      <li>
        <a
          href="/#/intro/view?id=44&tid=5"
          class="item item1"
          target="_blank"
        >
          <div class="tit" />
        </a>
      </li>
      <li>
        <a
          href="/#/intro/view?id=45&tid=5"
          class="item item2"
          target="_blank"
        >
          <div class="tit" />
        </a>
      </li>
      <li>
        <a
          href="/#/intro/view?id=47&tid=5"
          class="item item3"
          target="_blank"
        >
          <div class="tit" />
        </a>
      </li>
      <li>
        <a
          href="/#/intro/view?id=46&tid=5"
          class="item item4"
          target="_blank"
        >
          <div class="tit" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    GoToIntroView (id, typeID) {
      this.$router.push({
        path: '/intro/view',
        query: {
          id: id,
          tid: typeID
        }
      })
    }
  }
}
</script>

<style scoped>
.gb-wrapper .content .side .nav-list .item .btn-go {
    margin-top: 40px;
    margin-left: 35px;
    width: 200px;
    height: 22px;
    background: #fff;
    border-radius: 15px;
    line-height: 22px;
    text-align: center;
    font-size: 16px;
    color: #333;
    transition: all .2s linear;
}
</style>



// WEBPACK FOOTER //
// src/components/common/side.vue